var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag is-light"},[_vm._v(" "+_vm._s(_vm.member.getFullName())+" "),_c('span',{on:{"click":function($event){return _vm.deselectUser(_vm.member)}}},[_c('Icon',{attrs:{"name":"icon-x"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }